import { useEffect, useState } from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";
import Header from "../components/header";
import Sidebar from "../components/sideBar";
//import MessagesList from "../pages/boiteASuggestion";
import CommandeDashboard from "../pages/commande";
import Dashboard from "../pages/dashboard";
import ArticleList from "../pages/gestionArticles";
import UserDashboard from "../pages/gestionUtilisateurs";

import Connexion from "../pages/connexion";
import AdminUser from "../pages/adminUser";
import AdminArticle from "../pages/adminArticlesPage";
import AdminCatMarq from "../pages/gestionCategoriesMarques";
//import AdminCommande from "../pages/adminCommande";
import Order from "../pages/ordersList";

import OrderDetails from "../pages/OrderDetail";
import OrderStat from "../pages/OrdersStats";
import Message from "../pages/adminMessages";
import Actualite from "../pages/adminActualite";

import ResetPassword from "../pages/resetPassword";
import VerificationToken from "../pages/verificationToken";

import ProfilUtilisateurModal from "../pages/profilUtilisateur";

function Layout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  useEffect(() => {
    const handleResize = () => {
      // 992px correspond à la breakpoint 'lg' de Bootstrap
      if (window.matchMedia("(min-width: 992px)").matches) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />

      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <main
        className="flex-grow-1 overflow-auto bg-light"
        style={{ padding: "1rem", marginLeft: isSidebarOpen ? "250px" : "0" }}
      >
        <Outlet />
      </main>
    </>
  );
}

const router = createBrowserRouter([
  {
    element: <Connexion />,
    path: "/",
  },
  {
    element: <ResetPassword />,
    path: "/reinitialisation",
  },
  {
    element: <VerificationToken />,
    path: "/verification",
  },

  {
    element: <Layout />,
    children: [
      {
        element: <Dashboard />,
        path: "/dashboard",
      },
      {
        element: <ArticleList />,
        path: "/gestion-articles",
      },
      {
        element: <UserDashboard />,
        path: "/gestion-utilisateurs",
      },
      {
        element: <CommandeDashboard />,
        path: "/commandes",
      },

      { path: "/admin-user", element: <AdminUser /> },
      { path: "/admin-articles", element: <AdminArticle /> },
      //{ path: "/admin-commande", element: <AdminCommande /> },
      { path: "/gestion-categories-marques", element: <AdminCatMarq /> },
      { path: "/order", element: <Order /> },
      { path: "/order/:id_panier", element: <OrderDetails /> },
      { path: "/order/stats", element: <OrderStat /> },
      { path: "/messages", element: <Message /> },
      { path: "/actualite", element: <Actualite /> },
      { path: "/profil", element: <ProfilUtilisateurModal /> },
    ],
  },
]);

export default router;
